import { jsx as _jsx } from "react/jsx-runtime";
import Settings from 'pages/Settings';
import { Route } from 'react-router';
var SettingsRoutes = function () {
    return ([
        _jsx(Route, { caseSensitive: true, path: '/settings', element: _jsx(Settings, {}) }, 'settings-route'),
    ]);
};
export default SettingsRoutes;
